<div class="container-fluid footer-main">  
  <div class="copyright-info">    
    Copyright &copy; {{year}}. National Board of Revenue. All rights reserved.    
  </div>    
  <div class="dev-info">    
    <div class="dev-by">
      Developed by
    </div>    
    <div class="image-container">
      <img
        src="../../../../assets/img/logo/synesisIT_logo.png" class="img-fluid" alt="Responsive image" />
    </div>      
  </div>  
</div>



  <!-- new design start -->
  <!-- <div class="row p-2">
    <div class="col-sm-5">
      <footer class="fontColor nbrText">&copy;{{year}} - National Board of Revenue(NBR)</footer>
    </div>
    <div class="col-sm-4">
      <footer class="fontColor">
        <div class="row">
          <div class="col-sm-7">
            <span class="created-by">
              Managed by
            </span>
          </div>
          <div class="col-sm-5">
            <img style="display: block;" src="../../../../assets/img/logo/synesisIT_logo.png"
              class="img-fluid synesis_logo" alt="Responsive image" />
          </div>
        </div>
      </footer>
    </div>
    <div class="col-sm-3">
      <footer class="art_logo_section">
        <div class="row">
          <div class="col-sm-9">
            <span class="created-by">
              Graphic
            </span>
          </div>
          <div class="col-sm-3">
            <img style="display: block;" src="../../../../assets/img/logo/art_logo.jpg" class="img-fluid art_logo"
              alt="Responsive image" />
          </div>
        </div>
      </footer>
    </div>
  </div> -->
  <!-- new design end -->